import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ChevronDownFilled from "../../assets/svg/ChevronDownFilled";
import BellIcon from "../../assets/svg/BellIcon";
import ChatIcon from "../../assets/svg/ChatIcon";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/actions/auth.action";
import { userTypes } from "../../utils/constants";
import { resetSearchData } from "../../store/actions/search.action";
import HamburgerIcon from "../../assets/svg/HamburgerIcon";
import { getNotificationList } from "@endpoints/notification.service";
import TrackIcon from "@assets/svg/TrackIcon";
import { Link } from "react-router-dom";

const Navbar = () => {
  const dispatch = useDispatch();
  const { logged_in, user, companyDetails } = useSelector(
    (state) => state.auth
  );
  const unseenCount = useSelector(
    (state) => state.messageReducer?.unseenCount || 0
  );
  const unreadNotification = useSelector(
    (state) => state.notification?.notification || 0
  );
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [showMenuOption, setShowMenuOption] = useState(false);
  const isReferrealAmbassador =
    user?.userType === userTypes.REFERRAL_AMBASSADOR;
  const isRecruiter = user?.userType === userTypes.RECRUITER;
  const isCandidate = user?.userType === userTypes.CANDIDATE;

  // Todo
  const isLoggedIn =
    ((logged_in && user && user?._id) || isReferrealAmbassador) &&
    user 
    // &&
    // user?.userName;

  const handleLogout = () => {
    setShowMenuOption(false);
    dispatch(logout());
    navigate("/");
    localStorage.removeItem("searchData");
    dispatch(resetSearchData());
  };

  // useEffect(() => {
  //   if (logged_in) {
  //     dispatch(fetchUnseenMessageCount());

  //     const intervalId = setInterval(() => {
  //       dispatch(fetchUnseenMessageCount());
  //     }, pollingInterval);

  //     return () => clearInterval(intervalId);
  //   }
  // }, [dispatch, logged_in, user]);

  return (
    <div className="sticky top-0 z-50">
      <div
        className={`w-screen ${
          pathname === "/" ? "" : "shadow-custom bg-white"
        }`}
      >
        <div
          className={`relative flex items-center justify-between mx-auto max-w-[1728px] py-3 ${
            pathname === "/" && "py-10"
          } ${
            pathname === "/" || !isLoggedIn
              ? "py-10 px-6 sm:px-24"
              : "pl-7 sm:pl-7 lg:pr-10 xl:pr-44 bg-white"
          }`}
        >
          {/* flex gap-16 */}
          <div className="flex items-center justify-between md:justify-start md:gap-16 flex-1">
            <div className="flex items-center gap-14 md:gap-4">
              <button className="md:hidden focus:outline-none">
                <HamburgerIcon className={"w-6 h-6"} />
              </button>
              {/* Logo */}
              <NavLink to="/" className="flex items-center hover:no-underline">
                <span
                  className={`font-montserrat font-normal text-2xl lg:text-4xl text-[#2E2E2E]`}
                >
                  C
                </span>
                <span
                  className={`font-montserrat mt-1 font-normal tracking-[0.2em] pl-px text-sm lg:text-lg`}
                >
                  OMTRACKED
                </span>
              </NavLink>
            </div>
            {isLoggedIn && (
              <div className="flex items-center gap-3 pr-9 md:pr-0">
                <button
                  className="flex rounded-full border hover:bg-gray-100 h-9 w-9 p-1.5 relative"
                  onClick={() =>
                    (isCandidate || isRecruiter || isReferrealAmbassador) &&
                    navigate("/messages")
                  }
                >
                  {unseenCount > 0 && (
                    <div className="w-3.5 h-3.5 p-1 rounded-full bg-[#C50000] flex items-center justify-center absolute top-1 right-1">
                      <span className="font-montserrat text-[9px] font-semibold text-white">
                        {unseenCount}
                      </span>
                    </div>
                  )}
                  <ChatIcon className={"w-full h-full"} fill={"black"} />
                </button>

                <Link
                  to={'/tracker'}
                  className="flex rounded-full border hover:bg-gray-100 h-8 w-8 p-1.5 relative"
                >
                  <TrackIcon className={"w-full h-full"} fill={"black"} />
                </Link>

                <button
                  onClick={() => navigate("/notifications")}
                  className="flex rounded-full border hover:bg-gray-100 h-9 w-9 p-1.5 relative"
                >
                  {unreadNotification > 0 && (
                    <div className="w-3.5 h-3.5 p-1 rounded-full bg-green-600 flex items-center justify-center absolute top-1 right-1">
                      <span className="font-montserrat text-[9px] font-semibold text-white">
                        {unreadNotification}
                      </span>
                    </div>
                  )}
                  <BellIcon className={"w-full h-full"} fill={"black"} />
                </button>

                {/* <Link
                  to={'/tracker-clone'}
                  className="flex rounded-full border hover:bg-gray-100 h-8 w-8 p-1.5 relative"
                >
                  <TrackIcon className={"w-full h-full"} fill={"black"} />
                </Link> */}
              </div>
            )}
          </div>

          {/* Buttons */}
          {!isLoggedIn ? (
            <div className="hidden md:flex">
              <div className="flex flex-1 items-center ">
                <button
                  type="button"
                  onClick={() => navigate("/login")}
                  className="flex items-center justify-center px-5 h-6 border-r-2 border-r-primary"
                >
                  <span className="text-primary font-normal text-sm">
                    Candidates
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/login")}
                  className="flex items-center justify-center px-5 h-6 border-r-2 border-r-primary"
                >
                  <span className="text-primary font-normal text-sm">
                    Recruitment Agents
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/login-ambassador")}
                  className="flex items-center justify-center px-5 h-6 border-r-2 border-r-primary"
                >
                  <span className="text-primary font-normal text-sm">
                    Referral Partners
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/hiring/login")}
                  className="flex items-center justify-center pl-5 h-6"
                >
                  <span className="text-primary font-normal text-sm">
                    Hiring Companies
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div className="hidden md:flex gap-5 items-center">
              {companyDetails?.name && (
                <p className="text-sm font-semibold text-primary">
                  {user?.userType === userTypes.HIRING_COMPANY
                    ? companyDetails?.name
                    : `(${companyDetails?.name})`}
                </p>
              )}

              <div
                className="w-max relative"
                onMouseEnter={() => setShowMenuOption(true)}
                onMouseLeave={() => setShowMenuOption(false)}
              >
                <div className="flex items-center gap-1.5">
                  <span className="font-montserrat font-semibold text-sm text-light-black">
                    {isReferrealAmbassador && "(Referral Ambassador) "}
                    {user?.firstName} {user?.lastName}
                  </span>
                  <div
                    className={`transition-all duration-500 ${
                      showMenuOption ? "rotate-0" : "-rotate-90"
                    }`}
                  >
                    <ChevronDownFilled fill="black" />
                  </div>
                  <div className="h-10 w-10 rounded-full justify-center items-center flex bg-[#E1E0E0] bg-nwhited shadow-xl">
                    {user?.profilePic ? (
                      <img
                        src={user?.profilePic}
                        className="h-full w-full object-cover rounded-full"
                        alt="profileImg"
                      />
                    ) : (
                      <span className="font-montserrat text-white font-semibold text-xl">
                        {user?.firstName?.charAt(0)}
                        {user?.lastName?.charAt(0)}
                      </span>
                    )}
                  </div>
                </div>
                {/* MENU OPTION CONTAINER */}
                {showMenuOption ? (
                  <div
                    onMouseEnter={() => setShowMenuOption(true)}
                    onMouseLeave={() => setShowMenuOption(false)}
                    className="flex flex-col rounded-xl absolute bg-white right-0 shadow-xl border overflow-hidden"
                  >
                    <span
                      onClick={() =>
                        navigate(`${isRecruiter ? "/profile" : "my-profile"}`)
                      }
                      className="cursor-pointer hover:bg-gray-100 rounded-lg px-3 py-2 font-montserrat text-xs font-medium text-light-text"
                    >
                      View Profile
                    </span>
                    {/* <span
                      onClick={() =>
                        navigate(
                          isCandidate
                            ? "/settings"
                            : isReferrealAmbassador
                            ? "/account"
                            : "/"
                        )
                      }
                      className="cursor-pointer hover:bg-gray-100 rounded-lg px-3 py-2 font-montserrat text-xs font-medium text-light-text"
                    >
                      My Account
                    </span>
                    <span
                      onClick={() => navigate("/change-password")}
                      className="cursor-pointer hover:bg-gray-100 rounded-lg px-3 py-2 font-montserrat text-xs font-medium text-light-text"
                    >
                      Change Password
                    </span>
                    <span
                      onClick={() => navigate("/settings")}
                      className="cursor-pointer hover:bg-gray-100 rounded-lg px-3 py-2 font-montserrat text-xs font-medium text-light-text"
                    >
                      Settings
                    </span> */}
                    <span
                      onClick={handleLogout}
                      className="cursor-pointer hover:bg-gray-100 rounded-lg px-3 py-2 font-montserrat text-xs font-medium text-light-text"
                    >
                      Logout
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
